import mapStyles from '../utilities/mapStyles';
import { MarkerClusterer } from "@googlemaps/markerclusterer";

export async function initMap() {
  const mapElements = document.querySelectorAll('.google-map, .acf-google-map');

  if (!mapElements) {
    return;
  }
  
  const { Map } = await google.maps.importLibrary('maps');
  const { StyledMapType } = await google.maps.importLibrary('maps');
  const { AdvancedMarkerElement, PinElement } = await google.maps.importLibrary('marker');

  mapElements.forEach(item => {
    if (!item) {
      return;
    }

    const markers = item.querySelectorAll('.google-map-marker'),
          data = item.dataset,
          myLatLng = { lat: parseFloat(data.lat), lng: parseFloat(data.lng)},
          styledMap = new StyledMapType(mapStyles, { name: 'Custom styles'});
    

    const map = new Map(item, {
      zoom: parseInt(data.zoom),
      center: myLatLng,
      disableDefaultUI: true,
      mapId: Math.random(),
      mapTypeControlOptions: {
        mapTypeIds: ['roadmap', 'satellite', 'custom_styles']
      }
    });

    const infoWindow = new google.maps.InfoWindow({
      content: "",
      disableAutoPan: true,
    });

    map.mapTypes.set('custom_styles', styledMap);
    map.setMapTypeId('custom_styles');

    const markersArr = [],
          markersToClusterers = [];

    markers?.forEach((marker, i) => {
      const markerData = marker.dataset;

      if (markerData) {
        markersArr.push({
            position: { lat: parseFloat(markerData.lat), lng: parseFloat(markerData.lng) },
            title: markerData.title
        });
      }
    })

    if (markersArr.length) {
      markersArr?.map((marker, i) => {
          let markerOptions = {
            map,
            position: marker.position
          };

          if (data.marker) {
            let markerContent = document.createElement('img');
                markerContent.src = data.marker;

            markerOptions.content = markerContent;
          }

          const googleMarker = new AdvancedMarkerElement(markerOptions);

          if (item.classList.contains('real-estate-full-map')) {

            googleMarker.addListener('click', () => {
              infoWindow.setContent(marker.title);
              infoWindow.open(map, googleMarker);

              const posts = document.querySelectorAll('#real-estate-full-map .real-estate-posts a'),
                    prevBtns = document.querySelectorAll('.real-estate-full-map-prev-btn-wrapper');

              if (posts.length) {
                posts.forEach(post => {
                  post.classList.add('d-none');
                });

                posts[i].classList.remove('d-none');
              }

              if (posts.length > 1) {
                prevBtns.forEach(btn => {
                  btn.classList.remove('d-none');
                  btn.classList.add('d-flex');
                });
              }
            });

            markersToClusterers.push(googleMarker);
          }
      });
    }

    if (markersToClusterers.length) {
      const renderer = {
        render({ count, position }) {
          let markerContent = document.createElement('div');
              markerContent.className = 'google-map-marker--real-estate-fullmap';
              markerContent.textContent = count;
  
            return new AdvancedMarkerElement({
                position,
                className: 'google-map-marker--real-estate-fullmap',
                content: markerContent
            });
        }
      }
  
      new MarkerClusterer({markers: markersToClusterers, map: map, renderer: renderer});
    }
  });
}

export default () => {
  window.initMap = initMap;
}
